export const initialState = [
  {
    text: "First Todo",
    description: "First Todo's Description",
    createdOn: +new Date() + 1,
  },
  {
    text: "Second Todo",
    description: "Second Todo's Description",
    createdOn: +new Date() + 2,
  },
  {
    text: "Third Todo",
    description: "Third Todo's Description",
    createdOn: +new Date() + 3,
  },
];
